import { InitOptions } from './types';

export const defaultOptions: Partial<InitOptions> = {
  displayMode: 'overlay',
  locale: 'en',
  allowLogout: false,
  theme: 'dark',
  variant: 'one-page',
};
